import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LayoutService } from 'src/app/services/layout.service';
import { Menu, NavService } from 'src/app/services/nav.service';
import { Organization, UserProfile, UserRoleTypes } from '../../web-api-client';
import { WtStorageService } from '../../wt-storage.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class SidebarComponent implements OnInit {
  public menuItems: Menu[] = [];
  public myBtnIdClicked: boolean = false;
  public margin: any = 0;
  public width: any = window.innerWidth;
  public leftArrowNone: boolean = true;
  public rightArrowNone: boolean = false;
  public currenUser: UserProfile;

  constructor(
    private navService: NavService,
    private router: Router,
    private localStore:WtStorageService,
    private layout: LayoutService,
    public _cds:ChangeDetectorRef
  ) {
    this.currenUser = this.localStore.getuser();
  }

  ngOnInit(): void {
    // Debug: Log organization settings
    console.log('=== SIDEBAR DEBUG ===');
    console.log('Organization Settings:', {
      enableServiceProvider: this.currenUser.organization.enableServiceProvider,
      enableVikModule: this.currenUser.organization.enableVikModule,
      enableEGovAutomation: this.currenUser.organization.enableEGovAutomation
    });

    this.navService.items.subscribe((menuItems) => {
      console.log('Original menu items count:', menuItems.length);

      if (this.currenUser.userRole == UserRoleTypes.User) {
        menuItems = menuItems.filter(d => d.title != 'Потребители' && d.title != 'Организации')
        console.log('After user role filter:', menuItems.length);
      }

      // Service Provider filter - but skip items controlled by eGov Automation
      if (!this.currenUser.organization.enableServiceProvider) {
        console.log('Filtering out Service Provider items (except eGov Automation items)...');
        menuItems = menuItems.filter(d => {
          // Keep items that are not service module items
          if (d.isServiceModule == false) {
            return true;
          }
          // Keep service items that are controlled by eGov Automation
          if (d.isEGovAutomation == true) {
            return true;
          }
          // Hide other service items
          return false;
        });
        menuItems.forEach(d => {
          if (d.children) {
            d.children = d.children.filter(s => {
              // Keep child items that are not service module items
              if (s.isServiceModule == false) {
                return true;
              }
              // Keep service child items that are controlled by eGov Automation
              if (s.isEGovAutomation == true) {
                return true;
              }
              // Hide other service child items
              return false;
            });
          }
          return d;
        });
        console.log('After Service Provider filter:', menuItems.length);
      }

      if (!this.currenUser.organization.enableVikModule) {
        console.log('Filtering out VIK Module items...');
        menuItems = menuItems.filter(d =>  d.isVIKModule == false);
        menuItems.forEach(d => {
          if (d.children) {
            d.children = d.children.filter(s =>  s.isVIKModule == false);
          }
          return d;
        });
        console.log('After VIK Module filter:', menuItems.length);
      }

      // When eGov Automation is enabled, show ONLY "Заявени Услуги" from service items
      // Hide: "Заяви Услуга", "Преглед на Услуги", "Услуги" menu, "Каса" menu, "Посредници"
      if (this.currenUser.organization.enableEGovAutomation) {
        console.log('eGov Automation mode: showing only "Заявени Услуги"...');
        menuItems = menuItems.filter(d => {
          // Keep items that are not affected by eGov Automation
          if (d.isEGovAutomation == false) {
            return true;
          }
          // For items affected by eGov Automation, only keep "Заявени Услуги"
          if (d.title === 'Заявени Услуги') {
            return true;
          }
          // Hide all other eGov Automation items
          return false;
        });
        menuItems.forEach(d => {
          if (d.children) {
            d.children = d.children.filter(s => {
              // Keep child items that are not affected by eGov Automation
              if (s.isEGovAutomation == false) {
                return true;
              }
              // For child items affected by eGov Automation, only keep "Заявени Услуги"
              if (s.title === 'Заявени Услуги') {
                return true;
              }
              // Hide all other eGov Automation child items
              return false;
            });
          }
          return d;
        });
        console.log('After eGov Automation filter:', menuItems.length);
      }

      this.menuItems = menuItems;
      console.log('Final menu items:', menuItems.map(m => m.title || m.headTitle1));
      console.log('=== END SIDEBAR DEBUG ===');

      // Use markForCheck instead of detectChanges to avoid assertion error
      this._cds.markForCheck();

      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter((items) => {
            if (items.path === event.url) {
              this.setNavActive(items);
            }
            if (!items.children) {
              return false;
            }

            items.children.filter((subItems) => {
              if (subItems.path === event.url) {
                this.setNavActive(subItems);
              }
              if (!subItems.children) {
                return false;
              }
              subItems.children.filter((subSubItems) => {
                if (subSubItems.path === event.url) {
                  this.setNavActive(subSubItems);
                }
              });
              return true;
            });
            return true;
          });
        }

        // Use markForCheck instead of detectChanges
        this._cds.markForCheck();
      });
    });
  }

  close() {
    if (this.width <= 1199) {
      document.querySelector('.sidebar-wrapper')?.classList.add('close_icon');
    }
  }

  //  Active Nav
  setNavActive(item: Menu) {
    this.menuItems.filter((menuItem) => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter((submenuItems) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }

  toggletNavActive(item: Menu) {
    if (!item.active) {
      this.menuItems.forEach((a) => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) {
          return false;
        }
        a.children.forEach((b) => {
          if (a.children?.includes(item)) {
            b.active = false;
          }
        });
        return true;
      });
    }
    item.active = !item.active;
  }

  sidebarToggle() {
    this.navService.collapseSidebar = !this.navService.collapseSidebar;
  }

  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  scrollToRight() {
    if (this.margin <= -2598 || this.margin <= -2034) {
      if (this.width === 492) {
        this.margin = -3000;
      } else {
        this.margin = -3250;
      }
      this.leftArrowNone = false;
      this.leftArrowNone = false;
    } else {
      this.leftArrowNone = false;
      this.margin += -this.width;
    }
  }
}
